/** Register a component for further usage in ComponentsRegistry */
export function registerComponent() {
    return function register(component, name) {
        var Instance = component;
        if (!Instance.displayName) {
            Instance.displayName = name;
        }
        Instance.__crComponentName = name;
        return Instance;
    };
}
//# sourceMappingURL=registerComponent.js.map